<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.gjsc1" alt style="white-space:normal;">
        <span style="white-space:normal;">&nbsp;&nbsp;</span>
        <img :src="images.gjsc2" alt style="white-space:normal;">
        <br style="white-space:normal;">
        <br style="white-space:normal;">
        <br style="white-space:normal;">
        <img :src="images.gjsc3" alt style="white-space:normal;">
        <span style="white-space:normal;">&nbsp;</span>
        <img :src="images.gjsc4" alt style="white-space:normal;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:14pt;font-family:Arial;">
            Finishing
            production line for Steel Bars
          </span>
        </b>
      </p>
      <p>
        <span style="font-size:10pt;font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Recent decades, in black metal smelting boundary of the world,
          there are some mini metallurgy factories appeared, which is secondary operation
          factory relative to its small yield. Mini metallurgy factories is more vibrant
          and more efficiency development tendency in black metal smelting boundary.
          Compared to integrative big steelmaking plant, the advantage of this kind of
          mini factory is less cost and less influence ecological environment.
        </span>
      </p>
      <p style="margin-left:40pt;text-indent:-40pt;">
        <span style="font-size:10pt;font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p style="margin-left:40.0pt;text-indent:-40.0pt;">
        <span style="font-size:10.0pt;font-family:&quot;color:black;">
          <span style="font-family:Arial;font-size:12px;">1.</span>
          <span style="font-family:Arial;font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Arial;font-size:12px;">
            Basic competitive
            edge of mini factory -- Flexible, simple, compact process, suitable for the
            market demand, short production
          </span>
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:10.0pt;font-family:&quot;color:black;">
          <span style="font-family:Arial;font-size:12px;">2.</span>
          <span style="font-family:Arial;font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Arial;font-size:12px;">
            Low
            investment, short construction period
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:10.0pt;font-family:&quot;color:black;">
          <span style="font-family:Arial;font-size:12px;">3.</span>
          <span style="font-family:Arial;font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Arial;font-size:12px;">
            According to different consumers, provide
            professional products.
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:10.0pt;font-family:&quot;color:black;">
          <span style="font-family:Arial;font-size:12px;">4.</span>
          <span style="font-family:Arial;font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Arial;font-size:12px;">
            In optimizing production cost conditions,
            the labor productivity is much higher.
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:10.0pt;font-family:&quot;color:black;">
          <span style="font-family:Arial;font-size:12px;">5.</span>
          <span style="font-family:Arial;font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:Arial;font-size:12px;">
            New technology and
            new equipment is updated constantly.
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:10pt;font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Mini metallurgy factory has compact design, and it has three basic
          process parts---electric furnace steel making, pouring and rolling.
        </span>
      </p>
      <p>
        <span style="font-size:10pt;font-family:&quot;color:black;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:10pt;font-family:Arial;">
          Our company could offer the turn-key service include design,
          equipment applying and pilot production.
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        gjsc1: require("../../../assets/img/common/gjsc1.jpg"),
        gjsc2: require("../../../assets/img/common/gjsc2.jpg"),
        gjsc3: require("../../../assets/img/common/gjsc3.jpg"),
        gjsc4: require("../../../assets/img/common/gjsc4.jpg"),
        gjsc5: require("../../../assets/img/common/gjsc5.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/gjsc.vue